import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink }                              from '@angular/router';
import { MatTabLink, MatTabNav, MatTabNavPanel }                          from '@angular/material/tabs';
import { filter }                                                         from 'rxjs/operators';

@Component({
  selector: 'pin-navtab',
  templateUrl: 'nav-tab.component.html',
  imports: [MatTabNav, MatTabLink, RouterLink]
})
export class NavTabsComponent implements OnInit, OnDestroy {
  @Input()
  routes;
  @Input()
  stretch;
  @Input()
  ariaLabel = '';
  @Input()
  tabPanel: MatTabNavPanel;
  active;
  eventSubscription;
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.getActiveTab();

    this.eventSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.getActiveTab();
        this.cdr.detectChanges();
      });
  }

  getActiveTab(): void {
    // Set active tab based on initial url
    this.active = this.routes.find(
      route => this.router.url.indexOf(this.getFirstLevelFromUrl(route.url)) > 0
    );
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  getFirstLevelFromUrl(url: string) {
    const firstIndexOfSlash = url.indexOf('/');
    return firstIndexOfSlash > -1 ? url.substring(0, firstIndexOfSlash) : url;
  }
}
